// extracted by mini-css-extract-plugin
export default {"content":"Applications_content__y1Bsl","title":"Applications_title__4D4B+"};